import { render } from "./MMiniAppsSection.vue?vue&type=template&id=5366eeb0"
import script from "./MMiniAppsSection.vue?vue&type=script&lang=ts"
export * from "./MMiniAppsSection.vue?vue&type=script&lang=ts"
script.render = render

export default script